<template>
    <div  class=" page no-top-bar">

        <div class="bg-custom-blue pb-14">
            <TopBarDetail
                :title="'ข้อมูลส่วนตัว'"
                :isShowBack="true"
                :isShowFavorite="false"
                :isShowShare="false"
                :isTextWhite="true"
                @clickBack="clickBack()"
            ></TopBarDetail>
            <div class="flex flex-col justify-center items-center">
                <div class="w-14 h-14">
                    <img class="w-full h-full" src="@/assets/icon/ic-user.svg" alt="">
                </div>
                <div class="border rounded flex justify-center items-center
                            text-20 text-white px-4 mt-2.5 custom-max-h custom-color"
                >
                        {{getLevelText()}}
                </div>
                <div class="mt-2.5 text-white text-26">
                    {{displayName}}
                </div>
            </div>
        </div>
        <div class="page-content flex flex-col justify-between">
            <div class="">
                <div class="mx-auto custom-size-img relative">
                    <img class="w-full h-full" src="@/assets/icon/ic-rectangle.svg" alt="">
                    <div class="point-text-postion w-full">
                        <div class="flex justify-center items-center text-26 text-green-1 font-bold">
                            <span>คุณมี &nbsp;</span>
                            <span>{{userPoints}}&nbsp;</span>
                            <span>คะแนน</span>
                        </div>
                    </div>
                </div>
                <div class="px-4 mt-5">
                    <div v-if="isHasData">
                        <FormShowProfile
                            v-model:setFormData="formData"
                        ></FormShowProfile>
                    </div>
                </div>
            </div>
            <div class="pt-20 px-4 py-3">
                <div>
                    <div class=" absolute bottom-3 right-4">
                        <img class=" h-4" src="../../../assets/logo/logo-bzb-new.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
// helper
import { StaticLevel,UserLevel } from "@/core/UserLevel/UserLevelDetail.js";
//mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import TopBarDetail from "@/components/Layout/TopBar/TopBarDetail.vue";
import FormShowProfile from "../component/FormShowProfile.vue";

export default {
    name: "Profile",
    mixins: [AuthPageMixin, ModalMixin],
    components: {
        TopBarDetail,
        FormShowProfile
    },
    data: function() {
        return {
            isHasData: false,
            formData: null,

            userPoints: null,
            displayName: null,
        }
    },
    created: function() {
        this.tracking.screenName('profile');
        this.tracking.event('profile', 'view_profile');
    },
    methods: {
        //#region mixin function
        onAccountInit: function() {
            this.formData = this.profileCustom;
            let profile = this.profile;
            if(profile) {
                this.userPoints = profile.updated_points.points
            }

            if (this.formData != null) {
                 this.isHasData = true;
                 this.displayName = this.formData.firstName + ' ' + this.formData.lastName;
            }
        },
        //#endregion mixin function

        clickSave: function() {
            let profile = this.$refs['form-profile'].submit();
            if (profile == null) {
                return;
            }
            if (!this.checkAcceptTerms()) {
                return;
            }

            this.confirmModal.clearModal()
                    .setMsg("Save comfirm?")
                    .show();
            this.confirmModal.onClickOk(async () => {

                this.loadingModal.show();
                if (await this.sendUpdateProfile(profile)) {
                    await this.getProfile();
                }
                this.loadingModal.hide();

            });
        },
        clickBack: function() {
            this.$router.back();
        },
        clickLogout: function() {
            console.log('clickLogout');
        },
        getLevelText: function () {
            if (this.isLogin) {
                this.level = {...StaticLevel};
                this.userLevel = new UserLevel();
                return this.userLevel.getLevelName(this.level);
            } else {
                return "";
            }
        },
    },
}
</script>
<style lang="scss" scoped>

    .page {
        padding-bottom: 0px;

        .page-content {
            min-height: calc(100vh - 260px);
        }
        .bg-custom-blue {
            background-image: url(../../../assets/bg/bg-splus-blue.png);
            background-size: 100% 100%;
            background-position: center center;
        }
        .custom-color {
            background-color: rgba(255, 255, 255, 0.2);
        }
        .custom-max-h {
            height: 22.5px;
        }
        .custom-size-img {
            max-width: 272px;
            margin-top: -25px;
        }
        .point-text-postion {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
